import { helpers } from '@vuelidate/validators';
import config from '../config';
export const passwordPolicies = Object.fromEntries(Object.entries(config.passwordPolicies).map(([key, reg]) => [
    key,
    // nosemgrep
    helpers.regex(new RegExp(reg)),
]));
